import { Box } from "@mui/material";
import React from "react";
import Tables from "../../../Components/Tables/Tables";

const Products = () => {
  return (
    <>
      <Box>
        <Tables title="Products List" />
      </Box>
    </>
  );
};

export default Products;
